export default __webpack_public_path__ + "static/Slide2-0e9d2616fe50ebac2bc2e6176ff45238.png";